import React from 'react'
// import { Segment, Portal, Loader } from 'semantic-ui-react'
import styled from 'styled-components'

const StyledSpinner = styled(({ size, ...rest }) => <svg {...rest} />)`
  animation: rotate 2s linear infinite;
  margin: ${props => (`-${props.size}px 0 0 -${props.size}px`)};
  width: ${props => (props.size)*2}px;
  height: ${props => (props.size)*2}px;
  
  & .path {
    stroke: ${props => (props.theme.primary)};
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }
  
  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`;

const Spinner = ({radius=20, strokeWidth=4}) => {
  const size = radius + strokeWidth + 1;
  return (
    <StyledSpinner viewBox={ `0 0 ${size * 2} ${size * 2}`} size={size}>
      <circle
        className="path"
        cx={ size }
        cy={ size }
        r={radius}
        fill="none"
        strokeWidth={strokeWidth}
      />
    </StyledSpinner>
  )
};

export default Spinner